class Favorites {

	constructor() {
    let element   = document.querySelector('.my-favorites-count');
    let favoriteCountElement = document.querySelector('.favorite-count');
    let favorites = [];
    let count     = 0;
    let enableClick = false;

    //preventing user to be able to click on destination icon before they all have been loaded.
    jQuery(function($) {
      $('.dot-icon-destinationbg').each((i,e) => {
        $(e).click(e => {
          e.preventDefault();
        })
      })
    });


    jQuery(document).on('favorites-user-favorites-loaded', function(event, favorites, intial_load) {
      favorites = favorites[0]['posts'];
      count     = Object.keys(favorites).length;

      if (count > 0) {
        element.innerHTML = count;
        element.parentElement.classList.remove('visually-hidden');
      }
    });

    jQuery(document).on('favorites-updated-single', function(event, favorites, post_id, site_id, status) {
      favorites = favorites[0]['posts'];
      count     = Object.keys(favorites).length;
      console.log(count);

      if (count > 0) {
        element.innerHTML = count;
        element.parentElement.classList.remove('visually-hidden');
      } else {
        element.parentElement.classList.add('visually-hidden');
      }
    });

  function addDestinationOnClick() {
       //* Adding/removing classes to items in favorites ON CLICK */
       jQuery(document).on('click','.dot-icon-destinationbg',function(event, favorites, post_id, site_id, status){
        event.preventDefault(); //prevent loading new window (href).
  
        let clickedButton = jQuery(this);
        let postid = clickedButton.data('postid');
      
        
        let submitFavorite = function()
        {
          var formData = {
            action : 'favorites_favorite',
            postid : postid,
            siteid : 1,
            status : 1,
          }
          jQuery.ajax({
            url: favorites_data.ajaxurl,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function(data){

                const favouriteExists = data.favorites[0].posts[data.favorite_data.id]
  
                if (favouriteExists !== undefined) {
                  clickedButton.addClass('isDestinationFav');
                } else {
                  clickedButton.removeClass('isDestinationFav');
                }
  
                jQuery(document).trigger('favorites-updated-single',[data.favorites, formData.post_id, formData.site_id, formData.status]);
                jQuery(document).trigger('favorites-update-all-buttons');
              
                if (count == 0) {
                favoriteCountElement.classList.add('visually-hidden');  
                }
  
            },
            error: function(data){
              if ( !Favorites.jsData.dev_mode ) return;
              console.log('There was an error saving the favorite.');
              console.log(data);
            }
          });
        }
  
        submitFavorite();
    });
  }
  
  /* Adding classes to items in favorites ON LOAD */
  jQuery(document).on('favorites-user-favorites-loaded', function(event, favorites, intial_load){

    if (!enableClick) {
      enableClick = true;

      addDestinationOnClick();
    }

     for (const [key, value] of Object.entries(favorites[0].posts)) {
        const customFavoriteElement = jQuery('[data-postid='+key+']');
        customFavoriteElement.addClass('isDestinationFav');
      }
   
  });



  }
}

export default Favorites;
